import { Outlet } from 'react-router-dom'

import { ErrorProvider } from '@/contexts/ErrorContext'

const BlankLayout = () => {
  return (
    <ErrorProvider>
      <div className='min-h-screen bg-gradient-to-r from-amber-400 to-yellow-300'>
        <Outlet />
      </div>
    </ErrorProvider>
  )
}

export default BlankLayout
